var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.125 10H16.875","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.25 4.375L16.875 10L11.25 15.625","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRightInline.defaultProps = {"width":"20","height":"20","role":"img","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
